/**
 * Free trial = first N campaign lessons (Stage 1 order). Everything else,
 * including every Gatekeeper exam, needs the Full Course.
 * Ownership comes from the Firestore-backed account snapshot; exams are also
 * blocked server-side in beginVerifiedExam.
 */
export const FREE_TRIAL_LESSON_COUNT = 5;

type StageLike = { id: number; classes: Array<{ id: string }> };

export function freeTrialClassIds(stages: StageLike[]): string[] {
  return [...stages]
    .sort((a, b) => a.id - b.id)
    .flatMap((s) => s.classes.map((c) => c.id))
    .slice(0, FREE_TRIAL_LESSON_COUNT);
}

export function isClassInFreeTrial(stages: StageLike[], classId: string): boolean {
  return freeTrialClassIds(stages).includes(classId);
}

export function freeTrialCompletedCount(stages: StageLike[], completedClassIds: string[]): number {
  const done = new Set(completedClassIds);
  return freeTrialClassIds(stages).filter((id) => done.has(id)).length;
}
